import * as navigate from 'app/area/shared/navigation';
import { ApplicationState } from 'app/types-store';
import { ActionDispatching } from 'app/types-shared';
import {
  ChangeCaseType,
  ChangeCaseTypeSuccess,
  ChangeCaseTypeFailure
} from './action-types';
import { api } from './api';
import { ErrorNotification } from 'app/infrastructure/notifications/user-messages';
import { whenIdle } from 'app/infrastructure/redux';
import { ClearUiDefinition } from 'app/area/case/draft/action-types';
import { isCaseViewModalOpen } from 'app/components/helpers';

export const actionCreators = {
  
  changeCaseType: (
    caseTypeId: number,
    draftId: number
  ): ActionDispatching<any, ApplicationState> =>

    whenIdle(async (dispatch: any, getState: () => ApplicationState) => {
      const state = getState().caseArea;
      try {
        dispatch(new ChangeCaseType(caseTypeId, draftId));
        const response = await api.changeCaseType(
          draftId,
          caseTypeId,
          state.editing.etag
        );
        dispatch(new ChangeCaseTypeSuccess(caseTypeId, draftId, response.etag));
        await dispatch(new ClearUiDefinition());
        isCaseViewModalOpen() ? navigate.toDraftCaseViewModal(draftId, {}) : navigate.toDraft(draftId, {});
      } catch (err) {
        dispatch(new ChangeCaseTypeFailure(caseTypeId, draftId));
        dispatch(new ErrorNotification(err.message));
        navigate.toDraft(draftId, {});
      }
    })
};
